import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate } from 'react-router-dom';

import { Modal } from '@/components/shared/modal';
import { CreateRestaurantIngredientForm } from '@/components/restaurant/ingredients/create-restaurant-ingredient-form';

export const CreateRestaurantIngredientModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const closeModal = () => {
    navigate('/restaurant/ingredients', { replace: true });
  };

  const isModalOpen = Boolean(
    useMatch({ path: '/restaurant/ingredients/create' }),
  );

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      title={t('ingredient.create')}
      description={t('ingredient.create-details')}
    >
      <CreateRestaurantIngredientForm closeModal={closeModal} />
    </Modal>
  );
};
